<template>
  <div class="variables-container p-4">
  
    <!-- System Variables -->
    <div v-if="systemVariables.length > 0" class="mt-4 mb-8">
      <h3 class="text-lg font-semibold text-gray-900 mb-4">{{ $t('system_variables') }}</h3>
      <div class="space-y-3">
        <div v-for="variable in systemVariables" :key="variable.key" 
             class="flex items-center gap-3 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <div class="flex-shrink-0">
            <svg class="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
          </div>
          <div class="flex-1">
            <div class="text-sm font-medium text-blue-900">{{ variable.label }}</div>
            <div class="text-lg font-bold text-blue-700">{{ variable.value }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Custom Variables -->
    <div v-if="customVariables.length > 0" class="mt-8 mb-8">
      <h3 class="text-lg font-semibold text-gray-900 mb-4">{{ $t('custom_variables') }}</h3>
      <div class="space-y-3">
        <div v-for="variable in customVariables" :key="variable.key" 
             class="flex items-center gap-3 p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
          <div class="flex-shrink-0">
            <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
            </svg>
          </div>
          <div class="flex-1">
            <div class="text-sm font-medium text-gray-900">{{ variable.key }}</div>
            <div class="text-lg font-bold text-gray-700">{{ variable.value }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div v-if="systemVariables.length === 0 && customVariables.length === 0" class="text-center py-12">
      <div class="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
        <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      </div>
      <h3 class="text-lg font-medium text-gray-900 mb-2">{{ $t('variables_empty_title') }}</h3>
      <p class="text-gray-600">{{ $t('variables_empty_description') }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import gameModule from "../modules/GameModule";

export default {
  name: 'Variables',
  computed: {
    systemVariables() {
      const variables = [];
      
      // Add score variable
      variables.push({
        key: 'score',
        label: this.$t('score'),
        value: gameModule.getVariableValue('score') || 0
      });
      
      // Add name variable if it exists
      const name = gameModule.getVariableValue('name')
      if (name) {
        variables.push({
          key: 'name',
          label: this.$t('name'),
          value: name
        });
      }
      
      return variables;
    },
    
    customVariables() {
      let gameVariables = gameModule.getAllVariables();
      console.log("customVariables()", gameVariables);
      if (!gameVariables) return []
      
      return Object.entries(gameVariables)
        .filter(([key]) => !gameModule.isSystemVariable(key)) // Exclude system variables
        .map(([key, value]) => ({
          key,
          value: value
        }))
    },
    
    debugInfo() {
      return {
        variablesCount: this.customVariables.length,
        systemVariablesCount: this.systemVariables.length,
        totalVariables: Object.keys(gameModule.getAllVariables() || {}).length
      }
    }
  }
}
</script> 